module.exports = __webpack_public_path__ + "static/portrety-6c2e08860c8c503f130632da69f23cd8.png";